import { useEffect, useState } from 'react';
import { api } from '@/api/client';

type Props = {
  /** Path as the API reports it, e.g. /api/items/1/photos/9/raw */
  src: string;
  alt?: string;
  className?: string;
};

/**
 * Photo endpoints sit behind the same bearer token as the rest of the API, and a
 * plain <img src> cannot carry it — the browser just gets a 401 and shows a broken
 * image. So fetch the bytes through the API client and hand the tag a blob URL.
 */
export function AuthedImage({ src, alt = '', className }: Props) {
  const [objectUrl, setObjectUrl] = useState('');

  useEffect(() => {
    const controller = new AbortController();
    let created = '';

    api
      .get(src.replace(/^\/api/, ''), { responseType: 'blob', signal: controller.signal })
      .then((response) => {
        created = URL.createObjectURL(response.data as Blob);
        setObjectUrl(created);
      })
      .catch(() => setObjectUrl(''));

    return () => {
      controller.abort();
      URL.revokeObjectURL(created);
    };
  }, [src]);

  if (!objectUrl) {
    return <div className={className} data-testid="photo-placeholder" />;
  }
  return <img src={objectUrl} alt={alt} className={className} />;
}
